import {DataType} from "../utils/types";
import {deleteFiles} from "../../DeleteFiles/features/deleteFiles";
import { createToast } from "../../Toast/features/createToast";

export const files = () => {
    const form = document.querySelector('form[name="testimonial"]') as HTMLFormElement
    const inputFile = form?.querySelector('input[type="file"]') as HTMLInputElement
    const wrapper = document.querySelector('.testimony__content .content__files') as HTMLDivElement
    const section = document.querySelector('.accordion-pictures') as HTMLElement
    let number = null as HTMLSpanElement | null
    if (section) {
        number = section.querySelector('.content__nbrPictures .number') as HTMLSpanElement
    }

    if (!inputFile) return;

    inputFile.addEventListener('change', () => {
        if (inputFile.files && inputFile.files.length > 0) {
            const formData = new FormData()

            for (let i = 0; i < inputFile.files.length; i++) {
                formData.append('files[]', inputFile.files[i])
            }

            fetch('/ajax/ambassadeur/testimonial/add-images',
                {
                    method: 'POST',
                    body: formData
                })
                .then(response => response.json())
                .then((data: DataType) => {
                    // Show Toast Message depending on the response
                    const containerToast = document.querySelector(
                      ".container-toast"
                    ) as HTMLSpanElement;
                    const input = document.querySelector('.toast-input') as HTMLInputElement
                    input.id = data.files ? 'testimonial_images_success' : 'testimonial_images_error'
                    createToast(input.id, containerToast);

                    if (!data.files) return

                    data.files.forEach((item) => {
                        const element = document.createElement('div')
                        element.classList.add('content__file')
                        element.setAttribute('data-id', String(item.id))
                        const img = document.createElement('img')
                        img.src = item.path
                        img.width = 100
                        img.alt = ''
                        element.appendChild(img)
                        element.innerHTML += `<a class="delete">
                                                  <svg class="icon" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" id="trash">
                                                    <path d="M13.3333 24.0001C13.687 24.0001 14.0261 23.8596 14.2761 23.6096C14.5262 23.3595 14.6667 23.0204 14.6667 22.6667V14.6667C14.6667 14.3131 14.5262 13.974 14.2761 13.7239C14.0261 13.4739 13.687 13.3334 13.3333 13.3334C12.9797 13.3334 12.6406 13.4739 12.3905 13.7239C12.1405 13.974 12 14.3131 12 14.6667V22.6667C12 23.0204 12.1405 23.3595 12.3905 23.6096C12.6406 23.8596 12.9797 24.0001 13.3333 24.0001ZM26.6667 8.00008H21.3333V6.66675C21.3333 5.60588 20.9119 4.58847 20.1618 3.83832C19.4116 3.08818 18.3942 2.66675 17.3333 2.66675H14.6667C13.6058 2.66675 12.5884 3.08818 11.8382 3.83832C11.0881 4.58847 10.6667 5.60588 10.6667 6.66675V8.00008H5.33333C4.97971 8.00008 4.64057 8.14056 4.39052 8.39061C4.14048 8.64065 4 8.97979 4 9.33342C4 9.68704 4.14048 10.0262 4.39052 10.2762C4.64057 10.5263 4.97971 10.6667 5.33333 10.6667H6.66667V25.3334C6.66667 26.3943 7.08809 27.4117 7.83824 28.1618C8.58839 28.912 9.6058 29.3334 10.6667 29.3334H21.3333C22.3942 29.3334 23.4116 28.912 24.1618 28.1618C24.9119 27.4117 25.3333 26.3943 25.3333 25.3334V10.6667H26.6667C27.0203 10.6667 27.3594 10.5263 27.6095 10.2762C27.8595 10.0262 28 9.68704 28 9.33342C28 8.97979 27.8595 8.64065 27.6095 8.39061C27.3594 8.14056 27.0203 8.00008 26.6667 8.00008ZM13.3333 6.66675C13.3333 6.31313 13.4738 5.97399 13.7239 5.72394C13.9739 5.47389 14.313 5.33341 14.6667 5.33341H17.3333C17.687 5.33341 18.0261 5.47389 18.2761 5.72394C18.5262 5.97399 18.6667 6.31313 18.6667 6.66675V8.00008H13.3333V6.66675ZM22.6667 25.3334C22.6667 25.687 22.5262 26.0262 22.2761 26.2762C22.0261 26.5263 21.687 26.6667 21.3333 26.6667H10.6667C10.313 26.6667 9.97391 26.5263 9.72386 26.2762C9.47381 26.0262 9.33333 25.687 9.33333 25.3334V10.6667H22.6667V25.3334ZM18.6667 24.0001C19.0203 24.0001 19.3594 23.8596 19.6095 23.6096C19.8595 23.3595 20 23.0204 20 22.6667V14.6667C20 14.3131 19.8595 13.974 19.6095 13.7239C19.3594 13.4739 19.0203 13.3334 18.6667 13.3334C18.313 13.3334 17.9739 13.4739 17.7239 13.7239C17.4738 13.974 17.3333 14.3131 17.3333 14.6667V22.6667C17.3333 23.0204 17.4738 23.3595 17.7239 23.6096C17.9739 23.8596 18.313 24.0001 18.6667 24.0001Z"
                                                          fill="currentColor"></path>
                                                    </svg>
                                                </a>`
                        wrapper?.appendChild(element)
                    })
                    if (number) {
                        const newNumber = (section.querySelectorAll('.content__file') as NodeListOf<HTMLElement>).length
                        number.innerText = String(newNumber)

                        if (newNumber < Number(section.getAttribute('data-limit'))) {
                            const upload = section.querySelector('.content__upload') as HTMLElement
                            const input = upload?.querySelector('input') as HTMLInputElement
                            const uploadSpace = upload?.querySelector('.upload-space') as HTMLElement
                            uploadSpace?.classList.remove('hidden')
                            input?.removeAttribute('disabled')
                        }
                    }
                    deleteFiles(section)
                })
        }
    })
}
